import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { Marker, MarkerCluster, InfoWindow } from 'vue3-google-map';
export default /*#__PURE__*/ _defineComponent({
    __name: 'locations',
    props: {
        title: { type: String, required: true },
        description: { type: String, required: true },
        locations: { type: Array, required: true },
        types: { type: Array, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const search = ref('');
        const activeFilters = ref([]);
        const filteredLocations = computed(() => {
            let reassignLocations = props.locations;
            if (activeFilters.value.length) {
                reassignLocations = reassignLocations.filter((location) => location.type.find((cat) => activeFilters.value.includes(cat.id)));
            }
            if (search.value) {
                reassignLocations = reassignLocations.filter((location) => search.value?.toLowerCase() === location.city.toLowerCase());
            }
            return reassignLocations;
        });
        const renderMarkerCluster = ({ count, position }) => new google.maps.Marker({
            label: {
                text: String(count),
                color: 'white',
            },
            position,
            icon: {
                url: '/app/themes/burando/public/images/map-marker-cluster.svg',
                scaledSize: new google.maps.Size(35, 35),
            },
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
        const filteredLocationCities = computed(() => {
            const cities = filteredLocations.value.map((location) => location.city.charAt(0).toUpperCase() + location.city.slice(1));
            // Filter duplicates out
            return [...new Set(cities)].sort();
        });
        const __returned__ = { props, search, activeFilters, filteredLocations, renderMarkerCluster, filteredLocationCities, get Marker() { return Marker; }, get MarkerCluster() { return MarkerCluster; }, get InfoWindow() { return InfoWindow; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
